<template>
  <div class="dashboard-container">
    <div class="chart-setting">
      <div class="period">
        <p>period</p>
      </div>
    </div>
    <div class="spm-chart-container">
      <SpmCompany />
      <SpmPercentage />
      <SpmSummary />
    </div>
  </div>
</template>
<script>
  import SpmCompany from '@/components/dashboard/spm-company.vue'
  import SpmPercentage from '@/components/dashboard/spm-percentage.vue'
  import SpmSummary from '@/components/dashboard/spm-summary.vue'
  export default {
    name : 'dashboard',
    components : {
      SpmCompany,
      SpmPercentage,
      SpmSummary
    },
    created(){
      const self = this
      self.$store.dispatch('toggleSidebar', false)
    }
  }
</script>

<style lang="scss">
@import "~/assets/scss/components/dashboard.scss";
</style>